import * as React from "react"
import { GatsbyImage } from "gatsby-plugin-image" 
import Video from "../components/video" 

class banner extends React.Component {
  componentDidMount() { 
    setTimeout(function(){ document.querySelector('.hero-banner .image--scaled').classList.remove('is-scaled');}, 1250);  
    setTimeout(function(){ document.querySelector('.hero-banner .title--animation').classList.add('is-inview');}, 2500);
  }
  render() { 
    if(this.props.image) {
      var image=<GatsbyImage image={this.props.image} alt="Introduction Image" className="bg-image" />;
    }
    if(this.props.video) {
      var video=<Video video={this.props.video} image={this.props.mobileImage} />;
    }
    if(this.props.comingSoon) {
      var comingSoon = <div className="coming--soon">View {this.props.caption}</div>;
    }
    return (
      <div className={"hero-banner overflow-hidden pos-rel h-125 mh-125vh m-150 flex flex-wrap image-with--caption "+this.props.mobile} data-title={this.props.caption}>
        <div className="align-self--top mt80 w-100 pt50 ma">
          {this.props.title}
        </div>
        <div className="bottom-banner--content w-100 align-self--bottom pos-rel z-2">
            {this.props.bottom}
        </div> 
        {comingSoon}
        <div className="bg-image--container image-scales--onscroll">
          {video}
          <div className="image-is--fading image--fades">
            <div className="image--scaled bg-image--container is-scaled"> 
               {image} 
            </div>
          </div>
        </div>
      </div>
    )
  }
} 

export default banner

 